define(['jquery'], function ($) {
   "use strict";

   return function (strId, map) {
      var self = this,
         BingMaps = window.Microsoft.Maps,

         m_jHolder = $("#" + strId),
         m_r,
         m_iDistanceToDraw = 30, // The distance between points
         m_bDrawing = false, // Whether the user is currently drawing
         m_bAnimating = false,
         m_iXLast = 0,
         m_iYLast = 0, // The last position saved to the path
         m_strPath, // The Raphael path string
         m_path, // The Raphael path object
         m_aPointPath, // The coordinates for the path
         m_fnOnShapeDrawn,

         getDistance = function (x1, y1, x2, y2) {
            var iXDifference = (x2 - x1),
               iYDifference = (y2 - y1);

            return Math.sqrt(
               (iXDifference * iXDifference) + (iYDifference * iYDifference)
            );
         },

         createPath = function (strPath, bAnim) {
            if (m_path) {
               m_path.remove();
            }

            m_path = m_r.path(strPath);
            m_path.attr({
               fill: '#000',
               'fill-opacity': (bAnim) ? 0 : 0.2,
               stroke: '#3b4449',
               'stroke-dasharray': (bAnim) ? undefined : "- ",
               'stroke-width': 3,
               'stroke-linejoin': 'round'
            });
         },

         resetShape = function () {
            m_bDrawing = false;
            m_path.remove();
            m_path = null;
         },

         initialize = function () {
            m_jHolder.on({
               "mousedown touchstart": function (e) {
                  if (m_bAnimating) {
                     return;
                  }

                  e.preventDefault();

                  m_bDrawing = true;
                  m_strPath = null;
                  m_aPointPath = [];
               },
               "mouseup touchend": function (e) {
                  e.preventDefault();
                  m_bDrawing = false;

                  // If the user did not draw a valid shape
                  if (m_aPointPath.length < 3) {
                     // Don't bother
                     return;
                  }

                  m_bAnimating = true;
                  map.addLassoPolyByPixels(m_aPointPath);
                  m_jHolder.removeClass("drawing");

                  createPath(m_strPath + " z", true);
                  m_path.animate({
                     opacity: 0,
                     transform: "s1.5"
                  }, 500, ">", function () {
                     resetShape();
                     m_bAnimating = false;
                     m_jHolder.removeClass("showing");
                     if (m_fnOnShapeDrawn) {
                        m_fnOnShapeDrawn();
                     }
                  });
               },
               "mousemove touchmove": function (e) {
                  if (m_bAnimating) {
                     return;
                  }
                  if (!m_bDrawing) {
                     return;
                  }

                  e.preventDefault();

                  var parentOffset = $(this).parent().offset(),
                     oev = e.originalEvent,
                     touches,
                     iX, iY;

                  if (oev.changedTouches) {
                     touches = oev.changedTouches;
                     iX = touches[0].pageX;
                     iY = touches[0].pageY;
                  } else {
                     iX = e.pageX;
                     iY = e.pageY;
                  }

                  iX -= parentOffset.left;
                  iY -= parentOffset.top;

                  var iXDifference = iX - m_iXLast,
                     iYDifference = iY - m_iYLast,
                     iDistance = getDistance(iX, iY, m_iXLast, m_iYLast),
                     strAddPath = " l " + iXDifference.toString() + " " + iYDifference.toString();

                  if (m_strPath) {
                     createPath(m_strPath + strAddPath);
                  }

                  if (iDistance > m_iDistanceToDraw) {
                     if (!m_strPath) {
                        m_strPath = "M " + iX.toString() + " " + iY.toString();
                     } else {
                        m_strPath += strAddPath;
                     }

                     var point = new BingMaps.Point(iX, iY);
                     m_aPointPath.push(point);

                     m_iXLast = iX;
                     m_iYLast = iY;
                  }

                  if (m_aPointPath.length > 90) {
                     window.alert("Your shape is too complicated. Please try drawing a more simple shape.");
                     resetShape();
                  }
               }
            });

            $(window).resize(function () {
               var iWidth = m_jHolder.width(),
                  iHeight = m_jHolder.height();
               m_r.setSize(iWidth, iHeight);
            });
         };

      self.start = function (fnOnShapeDrawn) {
         require(['raphael'], function (Raphael) {
            m_jHolder.addClass("drawing showing");
            m_fnOnShapeDrawn = fnOnShapeDrawn;

            m_r = new Raphael(strId);
         });
      };

      self.stop = function () {
         if (m_fnOnShapeDrawn) {
            m_fnOnShapeDrawn();
         }
         m_bDrawing = false;
         m_jHolder.removeClass("showing");
      };

      initialize();
   };
});
